import { Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'
import Filterable from '@ui/Filterable'
import { PaymentPlan } from '@client/PaymentPlan'
import { PaymentPlanInstalment } from '@client/PaymentPlanInstalment'
import BillingRequest, { InitialPayment } from '@client/BillingRequest'

@Injectable()
export class BillingService extends BaseService<Filterable> {
	public createMandateRequest = async (
		order_id: number,
		redirect_uri: string,
		exit_uri: string,
		include_initial_payment: boolean,
		initial_payment?: number,
	): Promise<BillingRequest> => {
		const response = await this.post('/api/billing/mandate', {
			order_id,
			redirect_uri,
			exit_uri,
			include_initial_payment,
			initial_payment: include_initial_payment ? initial_payment : undefined,
		})

		return new BillingRequest(
			response.auth_url,
			response.redirect_uri,
			response.exit_uri,
		)
	}

	public createSchedule = async (
		order_id: number,
		plan: PaymentPlan,
		initial_payment?: InitialPayment,
	): Promise<PaymentPlan> => {
		const response = await this.post('/api/billing/schedules', {
			order_id,
			plan: {
				total_amount: plan.total_amount,
				instalments: plan.instalments.map(
					(instalment: PaymentPlanInstalment) => ({
						amount: instalment.amount,
						due_date: instalment.due_date.toISOString(),
					}),
				),
			},
			initial_payment,
		})

		return new PaymentPlan(
			response.id,
			response.currency,
			response.service,
			response.service_id,
			response.total_amount,
			response.instalments.map(
				(instalment: any): PaymentPlanInstalment =>
					new PaymentPlanInstalment(
						instalment.id,
						instalment.amount,
						new Date(instalment.due_date),
					),
			),
		)
	}
}
